import React from 'react';
import styled from 'styled-components';
import Popup from 'reactjs-popup';




function Reference(props) {

 function goToPublication(){
     window.location.href = props.publicationLink;
 }


 function copyToClipboard() {
    var textField = document.createElement('textarea')
    textField.innerText = props.clipBoardText
    document.body.appendChild(textField)
    textField.select();
    document.execCommand('copy')
    textField.remove();
  };

//<RefTitle>{props.title}</RefTitle>

  return (
    <Container>

        <Ref>{props.clipBoardText} </Ref>
        <ButtonsContainer>

        <StyledPopup
        trigger={open => (
            <Button onClick={() => copyToClipboard()}>
                <svg viewBox="64 64 896 896" focusable="false" class="" data-icon="copy" width="2em" height="2em" fill="currentColor" aria-hidden="true"><path d="M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"></path></svg>
            </Button>
            )}
            position="top center"
            closeOnDocumentClick
            on={['hover', 'focus']}
          >
            <Span> Copy To Clipboard </Span>
          </StyledPopup>

          <StyledPopup
          trigger={open => (
               <Button onClick={()=> goToPublication()}>
                  <svg viewBox="64 64 896 896" focusable="false" class="" data-icon="link" width="2em" height="2em" fill="currentColor" aria-hidden="true"><path d="M574 665.4a8.03 8.03 0 00-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 00-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 000 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 000 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 00-11.3 0L372.3 598.7a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z"></path></svg>
               </Button>
              )}
              position="top center"
              closeOnDocumentClick
              on={['hover', 'focus']}
            >
              <Span> Go To Publication </Span>
            </StyledPopup>


        </ButtonsContainer>
    </Container>


  );
}




const Container = styled.div`
	display:flex;
	flex-direction:row;
	justify-content:space-around;

`;

const Ref = styled.p`
	font-family:"Fira Sans";
	font-style: italic;
	width: 80%;
`;

// const RefTitle = styled.p`
// 	font-family:"Fira Sans";
// 	font-weight: bold;
//     width:10%;
// `;

const ButtonsContainer = styled.div`
	display:flex;
	flex-direction:row;
	width:7%;
	justify-content:space-between;
`;

const Button = styled.div`
	height:2em;
	&:hover {
	 cursor:pointer;
	}
`;

const Span = styled.span`
	margin-left: 10px;
	margin-right: 10px;
	font-family:"Fira Sans";
`;

const StyledPopup = styled(Popup)`

  &-overlay {
    position: fixed;
    inset: 0px;
    z-index: 999;
    pointer-events: none;
    background: transparent;
  }

  &-content {
		color:#fff;
		background-color:#545456;
    position: absolute;
    z-index: 999;
    pointer-events: auto;
    top: 187.5px;
    left: 626.766px;
    box-shadow: 0 0 3px rgb(0 0 0 / 16%);
    border-radius: 5px;
  }

  &-arrow{

    -webkit-filter: drop-shadow(0 -3px 3px rgba(0,0,0,.16));
    filter: drop-shadow(0 -3px 3px rgba(0,0,0,.16));
    color: #545456;
    stroke-width: 2px;
    stroke: #d7d7d7;
    stroke-dasharray: 30px;
    stroke-dashoffset: -54px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

`;





export default Reference;



// WEBPACK FOOTER //
// ./src/components/reference.js